import { createReducer } from '@reduxjs/toolkit';
import { MetaType } from 'shared/ts-types/meta-type';
import { adminRolesActions } from 'features/admin-roles/redux/admin-roles.actions';
import {
  RoleResponse,
  RoleWithPermissionsResponse,
} from 'features/admin-roles/api/types';

const initialState = {
  items: [] as RoleResponse[],
  meta: {
    itemCount: 0,
    totalItems: 0,
    itemsPerPage: 0,
    totalPages: 0,
    currentPage: 1,
  } as MetaType,
  loading: false as boolean,
  isLoaded: false as boolean,
  isSubmitted: false as boolean,
  selectedRole: {} as RoleWithPermissionsResponse,
  error: {
    adminRolesList: [] as string[],
    createRole: [] as string[],
    getRole: [] as string[],
    updateRole: [] as string[],
    deleteRole: [] as string[],
    deleteRoles: [] as string[],
  },
};

const adminRoles = createReducer(initialState, (builder) => {
  builder.addCase(adminRolesActions.clearAdminRolesList, () => {
    return {
      ...initialState,
    };
  });
  builder.addCase(adminRolesActions.getAdminRolesListRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(
    adminRolesActions.getAdminRolesListSuccess,
    (state, action) => {
      return {
        ...state,
        items:
          action.payload.meta.currentPage === 1
            ? action.payload.items
            : [...state.items, ...action.payload.items],
        meta: action.payload.meta,
        loading: false,
        isLoaded: true,
      };
    }
  );
  builder.addCase(
    adminRolesActions.getAdminRolesListFailure,
    (state, action) => {
      return {
        ...state,
        loading: false,
        isLoaded: false,
        error: { ...state.error, adminRolesList: action.payload },
      };
    }
  );

  builder.addCase(
    adminRolesActions.getAdminRolesByPartnerNameRequest,
    (state) => {
      return {
        ...state,
        loading: true,
      };
    }
  );
  builder.addCase(
    adminRolesActions.getAdminRolesByPartnerNameSuccess,
    (state, action) => {
      return {
        ...state,
        items: [...action.payload.items],
        loading: false,
        isLoaded: true,
      };
    }
  );
  builder.addCase(
    adminRolesActions.getAdminRolesByPartnerNameFailure,
    (state, action) => {
      return {
        ...state,
        loading: false,
        isLoaded: false,
        error: { ...state.error, adminRolesList: action.payload },
      };
    }
  );

  builder.addCase(adminRolesActions.createRoleRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(adminRolesActions.createRoleSuccess, (state, _) => {
    return {
      ...state,
      loading: false,
      isLoaded: true,
      isSubmitted: true,
    };
  });
  builder.addCase(adminRolesActions.createRoleFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: false,
      error: { ...state.error, createRole: action.payload },
    };
  });

  builder.addCase(adminRolesActions.getRoleRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(adminRolesActions.getRoleSuccess, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: true,
      selectedRole: action.payload,
    };
  });
  builder.addCase(adminRolesActions.getRoleFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: false,
      error: { ...state.error, getRole: action.payload },
    };
  });

  builder.addCase(adminRolesActions.updateRoleRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(adminRolesActions.updateRoleSuccess, (state, _) => {
    return {
      ...state,
      loading: false,
      isLoaded: true,
      isSubmitted: true,
    };
  });
  builder.addCase(adminRolesActions.updateRoleFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: false,
      error: { ...state.error, updateRole: action.payload },
    };
  });

  builder.addCase(adminRolesActions.deleteRoleRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(adminRolesActions.deleteRoleSuccess, (state, action) => {
    return {
      ...state,
      loading: false,
      items: state.items.filter((item) => item.id !== action.payload),
    };
  });
  builder.addCase(adminRolesActions.deleteRoleFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: false,
      error: { ...state.error, deleteRole: action.payload },
    };
  });

  builder.addCase(adminRolesActions.deleteRolesRequest, (state) => {
    return {
      ...state,
      loading: true,
    };
  });
  builder.addCase(adminRolesActions.deleteRolesSuccess, (state, action) => {
    return {
      ...state,
      loading: false,
      items: state.items.filter((item) => !action.payload.includes(item.id)),
    };
  });
  builder.addCase(adminRolesActions.deleteRolesFailure, (state, action) => {
    return {
      ...state,
      loading: false,
      isLoaded: false,
      error: { ...state.error, deleteRoles: action.payload },
    };
  });
});

export default adminRoles;
